module.exports = __webpack_public_path__ + "static/media/p1.e7e53fb4.jpg";